<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!--Chart content-->
  <div class="row common-page-contentwrap">
    <div class="col-md-12">
      <div [hidden]="pgLoad">
        <div class="adjust loader-container">
          <div class="loader2"></div>
        </div>
      </div>
      <!-- breadcrumb -->
      <div [hidden]="!pgLoad" class="row">
        <div class="col-md-12">
          <div class="page-breadcrumb">
            <ul class="page-breadcrumb__trail">
                <li><a>Metrics</a></li>
                <li><a>Harvest</a></li>
              </ul>
            <div class="page-breadcrumb__icons">
              <a routerLink="/home/dashboard"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>        
            </div>
          </div>
        </div>
      </div>
      <!-- breadcrumb End -->
      <div class="block" [hidden]="!pgLoad">
        <div class="screen_heading_div">
          <span>Harvest</span>
        </div>
        <div class="metrics-cards_container row">
          <!-- Harvest grid -->
          <div [hidden]="!pgLoad" class="row">
            <div [hidden]="!pgLoad" class="col-xs-12">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 fcr_chart">
                <div class="x_chart_panel   ">
                  <div class="x_chart_title">
                    <h2><strong>  {{charttitle}}</strong></h2>
                    <ul class="nav navbar-right chart_panel_toolbox">
                      <li><img src="../../../../../../assets/img/metrics_icons/piechart.svg" width="20px"
                               (click)="docgraphselection('doughnut')"
                               [ngClass]="docType == 'doughnut'?('colorblue'):('colorblack')" height="17px"/>
                      </li>
                      <li><img src="../../../../../../assets/img/metrics_icons/reports.svg" width="20px"
                               (click)="docgraphselection('bar')"
                               [ngClass]="docType == 'bar'?('colorblue'):('colorblack')" height="17px"/>
                      <li><img aria-hidden="true" data-toggle="modal" data-target="#docModal" width="20px" height="17px"
                               (click)="getAllDocLocation()"
                               src="../../../../../../assets/img/metrics_icons/location.svg"/></li>
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                  <div class="x_content">
                    <div id="canvasarea">
                      <canvas id="docmyChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>

              <!--harvested by doc details list-->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <p class="panel panel-default x_chart_panel nodata"
                   *ngIf="docDetailsList && docDetailsList.length == 0"> No data found</p>
                <div class="panel panel-default" *ngIf="docDetailsList && docDetailsList.length > 0">
                  <div class="col-lg-12">
                    <div class="metrics-search_button_container">
                      <div class="search-div">
                        <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="searchDocBusiness()" [(ngModel)]="docsearch"
                               name="search" autocomplete="off" placeholder="search..">
                      </div>
                    </div>
                  </div>
                  <div class="panel-body table-responsive tablescroll">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th>Business Name</th>
                        <th>Pond Name</th>
                        <th>Section Name</th>
                        <th>Harvested by DOC</th>
                      </tr>
                      </thead>
                      <tbody>
                      <div [hidden]="responseLoad">
                        <div class="adjust">
                          <div class="loader2 loaderstyle"></div>
                        </div>
                      </div>
                      <tr class="searchfundoc" *ngFor="let list of docDetailsList">
                        <td>{{list && list.FarmSiteBusinessEntity[0] && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName}}</td>
                        <td>{{list && list.name}}</td>
                        <td>{{(list && list.PondSection && list.PondSection.section_name == null) ? '--' : (list && list.PondSection && list.PondSection.section_name)}}</td>
                        <td>{{(list && list.doc == null) ? 'Culture Close' : (list && list.doc)}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!--harvested by doc list end-->
            </div>
          </div>
          <!--harvest sr graph with data-->
          <div [hidden]="!pgLoad" class="row">
            <div [hidden]="!pgLoad" class="col-xs-12">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 fcr_chart">
                <div class="x_chart_panel   ">
                  <div class="x_chart_title">
                    <h2><strong>  {{srcharttitle}}</strong></h2>
                    <ul class="nav navbar-right chart_panel_toolbox">
                      <li><img src="../../../../../../assets/img/metrics_icons/piechart.svg" width="20px"
                               (click)="srgraphselection('doughnut')"
                               [ngClass]="srType == 'doughnut'?('colorblue'):('colorblack')" height="17px"/>
                      </li>
                      <li><img src="../../../../../../assets/img/metrics_icons/reports.svg" width="20px"
                               (click)="srgraphselection('bar')"
                               [ngClass]="srType == 'bar'?('colorblue'):('colorblack')" height="17px"/>
                      <li><img aria-hidden="true" data-toggle="modal" data-target="#survivalRateModal" height="17px"
                               width="20px"
                               (click)="getAllSRLocation()"
                               src="../../../../../../assets/img/metrics_icons/location.svg"/></li>
                    </ul>
                    <div class="clearfix"></div>
                  </div>
                  <div class="x_content">
                    <div id="srcanvasarea">
                      <canvas id="srmyChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>
              <!--survival rate list-->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <p class="panel panel-default x_chart_panel nodata"
                   *ngIf="survivalRateDetails && survivalRateDetails.length == 0"> No data found</p>
                <div class="panel panel-default" *ngIf="survivalRateDetails && survivalRateDetails.length > 0">
                  <div class="col-lg-12">
                    <div class="metrics-search_button_container">
                      <div class="search-div">
                        <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="searchBusiness()" [(ngModel)]="search"
                               name="search" autocomplete="off" placeholder="search..">
                      </div>
                    </div>
                  </div>
                  <div class="panel-body table-responsive tablescroll">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th>Business Name</th>
                        <th>Pond Name</th>
                        <th>Section Name</th>
                        <th>Survival Rate</th>
                      </tr>
                      </thead>
                      <tbody>
                      <div [hidden]="responseLoad">
                        <div class="adjust">
                          <div class="loader2 loaderstyle"></div>
                        </div>
                      </div>
                      <tr class="searchfun" *ngFor="let list of survivalRateDetails">
                        <td>{{list && list.FarmSiteBusinessEntity[0] && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName}}</td>
                        <td>{{list && list.name}}</td>
                        <td>{{(list && list.PondSection && list.PondSection.section_name == null) ? '--' : (list && list.PondSection && list.PondSection.section_name)}}</td>
                        <td>{{(list && list.survivalRate == null) ? 'UA' : (list && list.survivalRate)}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--harvest sr graph with data end-->
          <!-- End Harvest grid -->
        </div>
      </div>
      <!-- SR Location details-->
      <div class="modal fade" id="survivalRateModal" role="dialog" *ngIf="srLocations && srLocations.length>0">
        <div class="modal-dialog active_location">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal" title="Close Popup">&times;
              </button>
              <h4 class="modal-title location_heading">Survival rate Location View</h4>
            </div>
            <div class="modal-body location_data  totalfarmermodelscrollbar" id="style-4">
              <div *ngFor="let location of srLocations" class="row">
                <div class="col-xs-12 location_state">
                  <p>{{location.state}}</p>
                </div>
                <div *ngFor="let village of location.data" class="doc_details col-lg-12">
                  <div class="col-xs-9 doc_villagename">
                    <span>{{village.village}}</span>
                  </div>
                  <div class="col-xs-3 doc_pondcount">
                    <p class="pull-right">{{village.count}} Pond(s)</p>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">UA</h3>
                      <h3 class="pull-right doc_count">{{village.undefinedCount}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">SR >100%</h3>
                      <h3 class="pull-right doc_count">{{village.greaterthan100}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">SR 91% - 100%</h3>
                      <h3 class="pull-right doc_count">{{village.survivalrate90to100}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">SR 80% - 90%</h3>
                      <h3 class="pull-right doc_count">{{village.survivalrate80to89}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">SR 71% - 79%</h3>
                      <h3 class="pull-right doc_count">{{village.survivalrate70to79}}</h3>
                    </div>
                    <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                      <h3 class="doc_heading">SR <span>&#8804;</span> 70%</h3>
                      <h3 class="pull-right doc_count">{{village.lessthan70}}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- SR Location details end -->
      <!-- doc Location details-->
      <div class="modal fade" id="docModal" role="dialog" *ngIf="docLocations && docLocations.length>0">
        <div class="modal-dialog active_location">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close close_btn" data-dismiss="modal" title="Close Popup">&times;
              </button>
              <h4 class="modal-title location_heading">Harvested by DOC Location View</h4>
            </div>
            <div class="modal-body location_data  totalfarmermodelscrollbar" id="style-4">
              <div *ngFor="let location of docLocations" class="row">
                <div class="col-xs-12 location_state">
                  <p>{{location.state}}</p>
                </div>
                <div *ngFor="let village of location.data" class="doc_details col-lg-12">
                  <div class="col-xs-9 doc_villagename">
                    <span>{{village.village}}</span>
                  </div>
                  <div class="col-xs-3 doc_pondcount">
                    <p class="pull-right">{{village.count}} Pond(s)</p>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">>120 days</h3>
                    <h3 class="pull-right doc_count">{{village.greaterthan120}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">100 - 120 days</h3>
                    <h3 class="pull-right doc_count">{{village.doc100to120}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">80 - 99 days</h3>
                    <h3 class="pull-right doc_count">{{village.doc80to99}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading">61 - 79 days</h3>
                    <h3 class="pull-right doc_count">{{village.doc61to79}}</h3>
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 doc_cards">
                    <h3 class="doc_heading"><span>&#8804;</span> 60 days</h3>
                    <h3 class="pull-right doc_count">{{village.lessthan60}}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
